/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { Spin } from 'antd';

const ModalLoader = () => {
  const style = useStyles(styleFn);

  return (
    <div css={style.overlay}>
      <Spin size="large" />
    </div>
  );
};

export default ModalLoader;

const styleFn: ThemedStyleFn = () => ({
  overlay: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
});
